import { CharacterCard } from '@/app/components/CharacterCard';
import type { Character } from '@/api';

interface CharactersGridProps {
  characters: Character[];
}

export function CharactersGrid({ characters }: CharactersGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {characters.map((character) => (
        <CharacterCard key={character._id} character={character} />
      ))}
    </div>
  );
}
